import { sanityClient } from '@/content/sanity/sanity-client/sanity-client';
import { ContactUsPageContent } from '../types/contact-us-content';

export async function fetchContent() {
  const contactUsPage: ContactUsPageContent = (
    await sanityClient.fetch(`*[_type == "contactUs"]{
    ...,
    contactOptions[]{
      ...,
      icon
    }
  }`)
  )?.[0];
  return contactUsPage;
}
